import { getMinOrZero } from './get-min-or-zero';
import { getMaxOrOne } from './get-max-or-one';

export const calcScaleLinearDomain = (data: any[], valueKey: string) => {
  const linearScaleDomain = [getMinOrZero(data, valueKey), getMaxOrOne(data, valueKey)];
  return linearScaleDomain;
}